import { useRef } from 'react';
import Footer from '@/components/Footer';
import Hero from '@/components/Reclamo';
import getMetadata from '@/utils/getMetadata';
import { NextSeo } from 'next-seo';
import localeManager from '@/utils/localeManager';
import useLangMenuBar from "@/hooks/useLangMenuBar";


const Contacto = ({ locale, footer, contact, country_short_name, show_complains_tyc, form, menu, id_type, localidades, distritos, provincias, departamentos }) => {
  const root = useRef();
  useLangMenuBar(menu)

  return (
    <main ref={root} className="relative site-max mx-auto contacto">
      <NextSeo
        {...getMetadata({
          locale,
          title: 'Reclamo',
          description:
            '¡Estamos para ayudarte! Dejanos tu consulta y nos pondremos en contacto en la brevedad.',
          pathname: '/reclamo'
        })}
      />
      <Hero localidades={localidades} distritos={distritos} provincias={provincias} departamentos={departamentos} id_type={id_type} show_complains_tyc={show_complains_tyc} customer_services_complain={footer.customer_services_complain} contact={contact} country_short_name={country_short_name} form={form} />
        <Footer footer={footer} locale={locale} />
    </main>
  );
};

export default Contacto;

export async function getServerSideProps({ req, locale: nextLocale, defaultLocale }) {
  const { locale, dict, resources } = await localeManager.getLocaleResources(req, {
    includeLocalidades: true,
    includeDistritos: true,
    includeProvincias: true,
    includeDepartamentos: true
  }, nextLocale || defaultLocale);

  return {
    props: {
      locale,
      footer: dict.home.footer,
      contact: dict.contact,
      country_short_name: dict.country_short_name,
      form: dict.contact.form,
      menu: dict.menu,
      show_complains_tyc: dict.complains.show_complains_tyc,
      id_type: dict.id_type,
      localidades: resources.localidades,
      distritos: resources.distritos,
      provincias: resources.provincias,
      departamentos: resources.departamentos,
    }
  };
}
